var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 4H11.5C11.2348 4 10.9804 4.10536 10.7929 4.29289C10.6054 4.48043 10.5 4.73478 10.5 5V10H5.5C5.23478 10 4.98043 10.1054 4.79289 10.2929C4.60536 10.4804 4.5 10.7348 4.5 11V27C4.5 27.2652 4.60536 27.5196 4.79289 27.7071C4.98043 27.8946 5.23478 28 5.5 28H21.5C21.7652 28 22.0196 27.8946 22.2071 27.7071C22.3946 27.5196 22.5 27.2652 22.5 27V22H27.5C27.7652 22 28.0196 21.8946 28.2071 21.7071C28.3946 21.5196 28.5 21.2652 28.5 21V5C28.5 4.73478 28.3946 4.48043 28.2071 4.29289C28.0196 4.10536 27.7652 4 27.5 4ZM20.5 26H6.5V12H20.5V26ZM26.5 20H22.5V11C22.5 10.7348 22.3946 10.4804 22.2071 10.2929C22.0196 10.1054 21.7652 10 21.5 10H12.5V6H26.5V20Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/_copy.6042552ec1b7efd7ca42838bd84765aa.svg";
export { ForwardRef as ReactComponent };